/* istanbul ignore file */
import useEmployeeOfferService from 'domain/people/employee/offers/shared/employeeOfferService';
import { useEmployeeOfferId, useEmployeeOfferUrl } from 'domain/people/employee/offers/employeeOfferRouting';
import { UpdateForm } from 'framework/form';
import { SensitiveUpdatePageLayout } from 'framework/sensitiveData';
import EmployeeOfferForm from 'domain/people/employee/offers/createupdate/EmployeeOfferForm';
import CopyEmployeeOfferButton from 'domain/people/employee/offers/shared/buttons/CopyEmployeeOfferButton';

const UpdateEmployeeOffer = () => {
  const { update, getById, getValidationSchema } = useEmployeeOfferService();
  const offerId = useEmployeeOfferId();
  const { getListUrl, getSingleEntityUrl } = useEmployeeOfferUrl();
  const listUrl = getListUrl();
  const updatedEntityUrl = getSingleEntityUrl(offerId);

  return (
    <UpdateForm
      getDataFunc={() => getById(offerId)}
      submitFormFunc={update}
      afterSubmit={{
        redirect: updatedEntityUrl,
        message: 'You are awesome! The Offer has been successfully updated.',
      }}
      getValidationSchemaFunc={getValidationSchema}
      entityId={offerId}
    >
      <SensitiveUpdatePageLayout
        title="Edit: Offer"
        titleVariant="h4"
        timerId={listUrl}
        toggleSensitiveDataButtonProps={{ size: 'small' }}
        titleActions={[<CopyEmployeeOfferButton key="copy-employee-offer" />]}
        hideActionsOnHiddenData
      >
        <EmployeeOfferForm isUpdate />
      </SensitiveUpdatePageLayout>
    </UpdateForm>
  );
};

export default UpdateEmployeeOffer;
